import type { LoginResult } from "../../../types/types";

export const isNewPasswordRequired = (
  res: LoginResult
): res is { newPasswordRequired: boolean } => {
  return !!res && 'newPasswordRequired' in res;
};